<template>
  <div class="tideng-layout">
    <div v-wechat-title="'《提灯与地下城》海灵主宰·龙拳破天'"></div>

    <!-- 子页面内容 -->
    <router-view :logger="logger" />

    <!-- tab 切换按钮 -->
    <div v-if="showTabs" class="section-tabs">
      <div class="tabs-box">
        <div v-for="(tab, index) in tabs" :key="index" class="tab-item"
          :class="['tab-' + tab.id, { active: isActive(tab.path) }]" @click="goTo(tab)">
          <img :src="isActive(tab.path) ? nav_active : nav_item">
          <div class="tab-item-text "> {{ tab.label }} </div>
        </div>
      </div>
    </div>
    <!-- <Footer :gameName="gameName" /> -->
    <!-- 微信下载 -->
    <div class="wechat_download_wrap popup_wrap" v-show="wxLoadShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="wx_download_wrap_content" @click="wxLoadShow = false"></div>
      </transition>
      <div class="close-bg" v-if="wxLoadShow" @click="wxLoadShow = false"></div>
    </div>
  </div>
</template>

<script>
import { getTimeStamp, buriedLogger, wechatBrowser, analysisParams } from "@/utils/utils";
import Footer from "@/components/Footer";
const nav_item   = 'https://download4.qcplay.com/h5-images/active/tideng/recall/nav.png';
const nav_active = 'https://download4.qcplay.com/h5-images/active/tideng/recall/nav_active.png';
export default {
  name: 'Layout',
  components: {
    Footer,
    nav_item,
    nav_active
  },
  data() {
    return {
      gameName: 'tideng',
      nav_item,
      nav_active,
      tabs: [
        { id: '1', label: '版本大焕新', path: 'anniversary' },
        { id: '2', label: '预约组队有礼', path: 'enter' },
        { id: '3', label: '更多活动', path: 'info' }
      ],
      logger: null,
      wxLoadShow: false,
      kol: '',
      currentTab: '',
    };
  },
  created() {
    if (!this.isMobile() && !window.location.href.includes('pc')) {
      window.location.href = `https://h5.qingcigame.com/tideng/recall/pc${getTimeStamp()}`;
      return;
    }

    const bl = buriedLogger('tideng', '拳新版本_layout');
    this.logger = bl;
    const params = analysisParams(window.location.href);
    const { kol } = params;
    this.kol = kol;
  },
  computed: {
    showTabs() {
      const currentPath = this.$route.path;
      return this.tabs.some(tab => currentPath.includes(tab.path));
    }
  },
  methods: {
    isMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i.test(
        userAgent
      );
    },
    isActive(tabPath) {
      return this.$route.path.includes(`/recall/${tabPath}`);
    },
    goTo(tab) {
      if (!this.isActive(tab.path)) {
        this.logger.sum('拳新版本_' + tab.label);
        this.$router.push(`/recall/${tab.path}`);
      }
    },
  }
};
</script>

<style lang="less" scoped>
@import url('~@/assets/css/active.less');
@mainImageUrl: "https://download4.qcplay.com/h5-images/active/tideng/recall/";

@font-face {
  font-family: 'HYQuHeiW';
  src: url('https://download4.qcplay.com/h5-images/active/tideng/recall/HYQuHeiW.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

.tideng-layout {
  height: 100vh;
  height: 100svh;
}

.section-tabs {
  position: absolute;
  bottom: 0rem;
  left: 50%;
  width: 750px;
  height: 139px;
  margin-left: -375px;
  display: flex;
  justify-content: space-between;
  background: url("@{mainImageUrl}bottom_nav_bg.png") no-repeat;
  background-size: 100% 100%;
  z-index: 98;

  .tabs-box {
    width: 712px;
    height: 96px;
    margin: 25px auto 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .tab-item {
      width: 250px !important;
      height: 88px !important;
      cursor: pointer;
      background-size: 100% 100%;
      font-family: HYQuHeiW;
      font-size: 42px;
      line-height: 88px;
      text-align: center;
      letter-spacing: -.1rem;
      transform: scale(.9);
      position: relative;

      img {
        width: 250px !important;
        height: 88px !important;
        z-index: 1;
        position: absolute;
        bottom: 0;
        left: 0;

      }

      .tab-item-text {
        font-family: HYQuHeiW;
        z-index: 9;
        position: relative;
      }
    }


    .tab-item:nth-child(2).active {

      .tab-item-text {
        transform: scaleX(.95);

      }
    }

    .tab-item.active {
      width: 250px;
      height: 88px;
      cursor: pointer;

      img {
        width: 258px !important;
        height: 107px !important;
        transform: scale(1.1) translateX(12px) translateY(-2px);
      }
    }

  }
}

.wechat_download_wrap {
  .wx_download_wrap_content {
    background: url(https://download4.qcplay.com/h5-images/active/snail/recall/download_bg.png) no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/tideng/recall/Layout.vue